<template>
  <!--  style="height:390px;" -->
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">意见反馈</span>
    </el-row>
    <div class="feedbackBox">
      <p>您的意见和建议是帮助我们不断完善的动力，感谢您对展恒基金一直以来的支持！</p>
      <div class="feedbackBox-con">
        <div class="feedbackBox-tit">内容或建议：</div>
        <el-input class=" textarea-one" type="textarea" :rows="9" placeholder="请输入您的意见或建议，谢谢！" v-model="textarea" resize="none">
        </el-input>
      </div>
      <div class="feedbackBox-con margin-b80">
        <div class="feedbackBox-tit ">添加图片或视频附件：</div>
        <el-upload class="upload-two" action list-type="picture-card" :file-list="fileList" :on-change="onChangeFile" :auto-upload="false">
          <i slot="default" class="el-icon-plus"></i>
          <div class="upload-two-text"><img src="../../assets/images/upload2.png" alt=""> 添加图片/视频</div>
          <div slot="file" slot-scope="{file}">
            <img v-if="file.name.split('.')[1] == 'mp4'" class="el-upload-list__item-thumbnail vedioImg" src="../../assets/images/upload3.png" alt="">
            <img v-else class="el-upload-list__item-thumbnail imageWay" :src="file.url" alt="">
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </div>
      <div style="text-align:center;">
        <el-button type="back" @click="empty">清空</el-button>
        <el-button type="normal" @click="submit">提交</el-button>
      </div>
    </div>
    <!-- 回访 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable" :close-on-click-modal="false">
      <div class="dialog-single-three-p">是否接受客户回访</div>
      <el-input class="margin-t20" v-model="username" placeholder="您的称呼"></el-input>
      <el-input class="margin-t20" v-model="phone" placeholder="您的联系方式"></el-input>
      <p class="margin-t20">选择接受回访不一定会收到回访，客服会根据实际情况决定是否回访。选择不接受回访则一定不会收到回访电话，请悉知。</p>
      <div class="margin-t30">
        <el-button type="back" style="width:152px;" @click="noAccept">{{noAcceptText}}</el-button>
        <el-button type="normal1" @click="accept">{{acceptText}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      textarea: '',
      //   上传
      disabled: false,
      fileList: [],
      dialogVisable: false,
      username: '',
      phone: '',
      acceptText: '接受回访',
      noAcceptText: '不接受直接提交',
    }
  },
  methods: {
    // 删除图片或视频
    handleRemove (file) {
      const tPic = file.index;
      const i = this.fileList.findIndex(item => item.index == tPic)
      this.fileList.splice(i, 1)
    },
    // 文件改变
    onChangeFile (file) {
      this.fileList.push(file)// 添加到数组
      this.fileList.forEach((item, i) => {
        item.index = i
      })
    },
    // 清空
    empty () {
      this.textarea = ''
      this.fileList = []
    },
    submit () {
      if (this.textarea == "") {
        this.$message.error('请填写意见后提交')
      } else {
        this.username = Base64.decode(this.$commonJs.getCookie('u_name1'))
        this.phone = this.$commonJs.getCookie('u_phone1')
        this.dialogVisable = true
      }
    },
    // 提交客服
    sendMsg (key) {
      let data = new FormData()
      this.fileList.forEach(item => {
        data.append('file', item.raw)
      })
      data.append('custno', this.$commonJs.getCookie('u_custno1'))
      data.append('content', this.textarea)
      data.append('visitInfo', key)
      this.$http.post(this.$apiPath.pushNewsModelSuggestApp, data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        if (res.data.code == "200") {
          this.$message.success('意见反馈成功')
        } else {
          this.$message.error('意见反馈失败')
        }
        this.acceptText = '接受回访'
        this.noAcceptText = '不接受直接提交'
        this.dialogVisable = false
        this.empty()
        // console.log(res);
      }).catch(err => { })
    },
    // 接受回访
    accept () {
      this.acceptText = '提交中...'
      this.sendMsg('pc接受回访，' + this.username + '，' + this.phone)
    },
    noAccept () {
      this.noAcceptText = '提交中...'
      this.sendMsg('pc不接受回访，' + this.username + '，' + this.phone)
    }
  },
}
</script>

<style lang="less" scoped>
.feedbackBox {
  margin: 35px;
  font-size: 16px;
  color: @color3;
  &-tit {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 12px;
    border-left: 4px solid @color;
    font-weight: bold;
  }
  &-con {
    margin-top: 30px;
  }
  .vedioImg {
    width: 80px;
    height: 60px;
    margin: 22px 11px;
  }
  .imageWay {
    height: 105px;
  }
}
</style>

